const messages = {
  de: {
    enums: {
      contractCategories: {
        INSURANCE: 'Versicherung',
        FINANCE: 'Finanzen',
        HABITATION_HOUSEHOLD_AND_COMMUNICATION: 'Wohnen, Haushalt & Kommunikation',
        LEISURE_AND_CLUB: 'Freizeit & Vereine',
        SUBSCRIPTION: 'Abonnement',
        ONLINE_SUBSCRIPTION_AND_SOCIAL_MEDIA_ACCOUNT: 'Online Abonnements & Social Media Accounts',
        OTHER: 'Sonstiges'
      },
      contractStatuses: {
        NOT_YET_PROCESSED: 'Noch nicht bearbeitet',
        INFORMATION_SENT: 'Informationsschreiben verschickt'
      },
      estateAdministrationTypes: {
        TRANSFER_TO_PERSON_OF_TRUST: 'An Kontaktperson übertragen',
        TERMINATE_CONTRACT: 'kündigen'
      },
      invitationStatus: {
        INVITED: 'Bestätigung ausstehend',
        INVITED_AND_REMINDER_SENT: 'Bestätigung ausstehend - Erinnerung versendet',
        REGISTERED: 'Registriert'
      },
      relationTypes: {
        SPOUSE: 'Ehepartner/in',
        COMPANION: 'Lebensgefährte/in',
        FRIEND: 'Freunde/Bekannte',
        EXTENDED_FAMILY: 'erweiterter Familienkreis',
        CHILD: 'Kind',
        SIBLING: 'Geschwister'
      },
      roles: {
        ADMIN: 'Admin',
        CONTACT_PERSON: 'Kontaktperson',
        POLICY_HOLDER: 'Versicherungsnehmer'
      },
      salutations: {
        MR: 'Herr',
        MRS: 'Frau'
      }
    },
    message: {
      accountDeactivationForm: {
        btn: {
          ok: 'Ja, löschen',
          cancel: 'Nein, abbrechen'
        },
        deactivate: 'Zur Kontodeaktivierung klicken Sie bitte {deactivateLink}',
        deactivateLink: 'hier',
        message: 'Wenn Sie fortfahren, werden alle Ihre gespeicherten Daten und Vertragsinformationen endgültig gelöscht',
        question: 'Sind Sie sicher, dass Sie Ihr Konto deaktivieren möchten?',
        title: 'Konto deaktivieren?'
      },
      accountDetails: {
        card: {
          title: {
            changeEmail: 'Email ändern',
            changePassword: 'Passwort ändern',
            deactivate: 'Konto Deaktivierung',
            powerOfAttorney: 'Meine Vollmacht'
          }
        },
        deletePowerOfAttorney: 'Ihre Vollmacht wurde erfolgreich widerrufen',
        saveChangedPassword: 'Das Passwort wurde erfolgreich geändert',
        saveChangedEmail: 'Ihre E-Mail-Adresse wurde erfolgreich geändert',
        savePersonalInfo: 'Ihre persönlichen Informationen wurden erfolgreich aktualisiert',
        title: 'Meine persönlichen Informationen'
      },
      accountPowerOfAttorneyForm: {
        btn: {
          browse: 'Durchsuchen',
          cancel: 'Nein, Abbrechen',
          ok: 'Ja, sicher',
          printPoa: 'Vollmacht',
          revokePoa: 'Vollmacht widerrufen?'
        },
        message: 'Sind Sie sicher, dass Sie Ihre Vollmacht wiederrufen möchten? Dadurch werden wir nicht mehr in der Lage sein, Ihre Vertragspartner nach Ihrem Ableben zu informieren.',
        pleaseUpload: 'Bitte laden Sie hier Ihre Vollmacht hoch. Erlaubte Formate: PDF, JPG und PNG.',
        title: 'Vollmacht widerrufen?',
        uploadSuccess: 'Vollmacht erfolgreich hochgeladen'
      },
      addressConfirmForm: {
        btn: {
          back: 'Zurück',
          submit: 'Speichern'
        },
        storeAddress: 'Die angegebene Adresse wurde erfolgreich gespeichert',
        subtitle: 'Bitte überprüfen Sie die erfassten Eingaben',
        title: 'Adresse prüfen'
      },
      addressDetails: {
        changedAdresses: 'Verträge erfolgreich geändert',
        btn: {
          back: 'Zurück',
          cancel: 'Abbrechen',
          delete: 'Löschen',
          edit: 'Bearbeiten',
          save: 'Speichern'
        },
        contractsCard: {
          title: 'Erfasste Verträge zu dieser Adresse'
        },
        deleteAddress: 'Die Adresse wurde erfolgreich gelöscht',
        modal: {
          btn: {
            cancel: 'Nein, behalten',
            ok: 'Ja, löschen'
          },
          question: 'Sind Sie sicher, dass Sie diese Adresse löschen möchten?',
          title: 'Adresse löschen'
        },
        moveBtn: 'Adresse ändern',
        moveMessage: 'Bitte wählen Sie hier, eine Adresse aus, die diesen Verträgen neu zugeordnet werden soll. Die enstprechenden Vertragspartner werden von uns via E-Mail über den Adresswechsel informiert. Parallel bekommen Sie ebenso eine PDF mit einer Liste von den betroffenen Vertragspartnern zur Einsicht.',
        moveMessageSingleAddr: 'Wir bieten Ihnen die Möglichkeit Ihre Vertragspartner über Adressänderungen zu informieren. Sie können über den Punkt “Adressen” im Navigationsbereich Ihre neue Adresse hinzufügen und im Nachgang diese auswählen um Ihre Vertragspartner über den Adresswechsel zu informieren. Ihre bereits angelegten Verträge werden sogleich der neuen Adresse zugeordnet.',
        moveTitle: 'Umzugsmitteilung',
        saveAddress: 'Die Adresse wurde erfolgreich geändert',
        title: 'Adressübersicht'
      },
      addressList: {
        addressInfo: {
          contactPerson: 'Hier können Sie Ihre derzeitige Wohnanschrift hinzufügen.',
          policyHolder: 'Hier können Sie Ihre derzeitige Wohnanschrift und etwaige Zweitwohnsitze hinzufügen. Dies wird benötigt um Ihren Vertrag zuordnen zu können und Ihrem Vertragspartner detaillierter informieren zu können.'
        },
        infobox: {
          message: '{numberOfContracts} Verträge zur Adresse',
          messageSingle: '1 Vertrag zur Adresse'
        },
        subtitle: 'Übersicht über angelegte Wohnorte',
        title: 'Adressen',
        subtitleNonPolicyHolder: 'Übersicht über Ihren angelegten Wohnort'
      },
      addressSearchForm: {
        btn: {
          submit: 'Weiter'
        },
        input: {
          placeholder: {
            autocomplete: 'Adresse, z.B. Kirchenstraße 1, Nürnberg'
          }
        },
        title: 'Neue Adresse erfassen'
      },
      addressForm: {
        label: {
          street: 'Straße',
          streetNumber: 'Hausnummer',
          additionalAddress: 'Addresszusatz',
          postalCode: 'Postleitzahl',
          city: 'Stadt',
          country: 'Land'
        }
      },
      adminContractPartnerDetails: {
        btn: {
          back: 'Zurück',
          delete: 'Löschen',
          save: 'Speichern'
        },
        label: {
          city: 'Stadt',
          country: 'Land',
          domain: 'Domain',
          email: 'E-Mail-Adresse',
          name: 'Name',
          street: 'Straße',
          streetNumber: 'Hausnummer',
          postalCode: 'Postleitzahl',
          postOfficeBox: 'Postfach'
        },
        saveContractPartner: 'Der angegebene Vertragspartner wurde erfolgreich als Template gespeichert',
        title: 'Vertragspartner',
        warning: 'ContractPartner die als Template generiert wurden, werden automatisch ins Suchfeld der Plattform übernommen.'
      },
      adminContractPartnerList: {
        card: {
          title: {
            contractPartners: 'Liste aller Vertragspartner',
            contractPartnerTemplates: 'Templates für Vertragspartner'
          }
        },
        table: {
          address: 'Adresse',
          approved: 'Geprüfte Adresse',
          email: 'E-Mail-Adresse',
          domain: 'URL / Domain',
          name: 'Name'
        },
        yes: 'Ja',
        no: 'Nein',
        title: 'Vertragspartner'
      },
      adminContractPartnerTemplateDetails: {
        deleteContractPartnerTemplate: 'Das angegebene Template wurde erfolgreich gelöscht',
        saveContractPartnerTemplate: 'Das angegebene Template wurde erfolgreich gespeichert',
        title: 'Vertragspartnertemplate'
      },
      adminUserAddress: {
        table: {
          city: 'Stadt',
          postalCode: 'PLZ',
          street: 'Straße',
          streetNumber: 'Hausnummer'
        },
        title: 'Adressen'
      },
      adminUserContactPerson: {
        table: {
          city: 'Stadt',
          confirmationStatus: 'Best. Status',
          dateOfBirth: 'Geburtsdatum',
          email: 'E-Mail',
          firstName: 'Vorname',
          heir: 'Erbe',
          lastName: 'Nachname',
          postalCode: 'PLZ',
          relation: 'Zugehörigkeit',
          street: 'Straße',
          streetNumber: 'Hausnummer'
        },
        title: 'Kontaktpersonen'
      },
      adminUserInvitation: {
        table: {
          contactPersonFirstname: 'Vorname',
          contactPersonLastname: 'Nachname',
          contactPersonEmail: 'E-Mail',
          createdAt: 'Datum',
          status: 'Status'
        },
        title: 'Einladungen'
      },
      adminContractsCard: {
        cancellationPeriod: 'Kündigungsfrist',
        conclusionDate: 'Vertragsabschluss',
        company: 'Firma',
        contractDuration: 'Vertragslaufzeit',
        contractNumber: 'Vertragsnummer',
        insuredPersonNumber: 'Kundennummer',
        insuranceNumber: 'Versicherungsnummer',
        noItems: 'Keine Daten vorhanden',
        time: {
          month: '{value} Monat',
          months: '{value} Monate'
        },
        type: 'Vertragstyp'
      },
      adminUserList: {
        isAuthorized: 'Ja',
        isNotAuthorized: 'Nein',
        perPage: 'Zeilen pro Seite',
        table: {
          id: 'ID',
          firstName: 'Vorname',
          lastName: 'Nachname',
          email: 'E-Mail-Adresse',
          dateOfBirth: 'Geburtsdatum',
          roles: 'Rollen',
          contractNumber: 'Vers.-Nr.',
          status: 'Status',
          registration: 'Registrierung',
          legitimation: 'Legitimation'
        },
        status: {
          death: 'Tot',
          alive: 'Lebend'
        },
        title: 'Nutzer'
      },
      adminUserDetail: {
        alive: 'Lebendig',
        dead: 'Tot',
        legitimation: 'Legitimation',
        no: 'Nein',
        save: 'Aktualisieren',
        status: 'Status',
        yes: 'Ja'
      },
      adminUserDocuments: {
        deleteDocument: 'Dokument entfernen',
        modal: {
          btn: {
            ok: 'Ja',
            cancel: 'Nein'
          },
          message: 'Möchten Sie das Dokument wirklich entfernen?',
          title: 'Dokument wirklich entfernen?'
        },
        noCod: 'Keine Sterbeurkunde vorhanden',
        noCoi: 'Kein Erbschein vorhanden',
        noPH: 'Kontaktpersonen haben keine Kontaktpersonen',
        uploadCod: 'Sterbeurkunde hochladen',
        uploadCoi: 'Erbschein hochladen',
        uploadPoa: 'Vollmacht hochladen',
        selectCP: 'Kontaktperson auswählen',
        viewCod: 'Sterbeurkunde einsehen',
        viewCoi: 'Erbschein einsehen',
        viewPoa: 'Vollmacht einsehen'
      },
      adminUserStatus: {
        update: {
          death: 'Sterbedatum erfolgreich aktualisiert',
          legi: 'Legitimationsstatus erfolgreich aktualisiert'
        }
      },
      accountChangeEmailForm: {
        btn: {
          save: 'Neue E-Mail-Adresse speichern'
        },
        label: {
          currentEmail: 'Alte E-Mail-Adresse',
          email: 'Neue E-Mail-Adresse',
          emailConfirm: 'Neue E-Mail-Adresse wiederholen'
        }
      },
      adminSidebar: {
        navItem: {
          account: 'Mein Account',
          dashboard: 'Übersicht',
          contractPartners: 'Vertragspartner',
          users: 'Nutzer'
        }
      },
      appHeader: {
        btn: {
          signOut: 'Abmelden'
        }
      },
      appSidebar: {
        navItem: {
          addresses: 'Adressen',
          account: 'Mein Account',
          contactPersons: 'Kontaktpersonen',
          contactPersonOf: 'Kontaktperson von:',
          contracts: 'Verträge',
          contractsOf: 'Verträge',
          dashboard: 'Übersicht',
          faq: 'Wissenswertes'
        }
      },
      avatar: {
        btn: {
          delete: 'Profilbild Löschen',
          no: 'Nein, abbrechen',
          yes: 'Ja, löschen'
        },
        default: 'Bild',
        delete: 'Bild erfolgreich gelöscht',
        maxFileDimensions: 'Hier können Sie Ihr Profilbild hochladen. Maximalgröße:',
        maxFileDimensionsValue: '{width} x {height}, 6MB',
        questionTitle: 'Profilbild löschen?',
        question: 'Sind Sie sicher, dass Sie Ihr Profilbild löschen möchten?',
        upload: 'Bild erfolgreich hochgeladen'
      },
      businessCard: {
        deceased: 'Verstorben am:',
        relation: 'Angehörigkeit:',
        status: 'Bestätigungsstatus:'
      },
      contractAddressDetails: {
        question: 'Welche Adresse ist auf diesem Vertrag angegeben?',
        noAddressHint: 'Es wurde noch keine Adresse hinzugefügt. Eine neue Adresse können Sie unter dem Navigationspunkt "Adressen" hinzufügen. An dieser Stelle können Sie den Schritt überspringen und zu einem späteren Zeitpunkt eine Adresse diesem Vertrag zuordnen.'
      },
      cookiePopup: {
        message: 'Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies.\nDurch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu. Weitere Informationen zu Cookies erhalten Sie in unserer Datenschutzerklärung.',
        ok: 'OK'
      },
      changePasswordForm: {
        btn: {
          save: 'Neues Passwort speichern'
        },
        label: {
          oldPassword: 'Altes Passwort',
          newPassword: 'Neues Passwort',
          newPasswordConfirm: 'Neues Passwort bestätigen'
        }
      },
      contactPersonDetails: {
        btn: {
          back: 'Zurück',
          delete: 'Löschen'
        },
        contractsCard: {
          cancellationPeriod: 'Kündigungsfrist',
          company: 'Firma',
          estateAdministration: 'Nachlasswunsch',
          status: 'Status',
          title: 'Verträge, über die {firstName} {lastName} informiert werden soll',
          type: 'Vertragstyp'
        },
        deleteContactPerson: 'Die von Ihnen ausgewählte Kontaktperson wurde erfolgreich gelöscht',
        modal: {
          btn: {
            ok: 'Ja, ich bin mir sicher',
            cancel: 'Nein, abbrechen'
          },
          title: 'Kontaktperson löschen',
          question: 'Sind Sie sicher, dass Sie {salutation} {firstName} {lastName} entfernen möchten? Sofern Sie dieser Person bereits Verträge zugeordnet haben, werden diese als nicht fertiggestellt gekennzeichnet'
        },
        title: 'Personenübersicht'
      },
      contactPersonDialog: {
        btn: {
          cancel: 'Abbrechen',
          submit: 'Kontaktperson einladen'
        },
        label: {
          email: 'E-Mail-Adresse',
          firstName: 'Vorname',
          lastName: 'Nachname',
          salutation: 'Anrede'
        },
        title: 'Neue Kontaktperson erfassen'
      },
      contactPersonList: {
        btn: {
          createContactPerson: 'Kontaktperson hinzufügen'
        },
        introductoryPhrase: 'Bestimmen Sie hier bitte Ihre Kontaktpersonen, die im Falle Ihres Ablebens Zugang zu Ihrem Digitalen Nachlassplaner erhalten sollen. Am besten bestimmen Sie als Kontaktperson Ihren Ehepartner oder Ihr Kind bzw. eine andere erbberechtigte Person. Damit sichern Sie ab, dass diese Person Ihren Digitalen Nachlassplaner bei Bedarf uneingeschränkt nutzen kann.',
        submitContactPersonDialog: 'Ihre Einladung an {email} wurde erfolgreich versandt',
        title: 'Kontaktpersonen'
      },
      contractEstateDetails: {
        infoTextWithContactPersons: 'Bestimmen Sie eine Kontaktperson, die nach Ihrem Ableben Einsicht in diesen Vertrag gewährt bekommt.',
        infoTextWithoutContactPersons: 'Sie haben noch keine bestätigte Kontaktperson. Sie können eine Kontaktperson diesem Vertrag zuordnen, nachdem diese bestätigt worden ist.'
      },
      contractWizard: {
        btn: {
          cancel: 'Abbrechen',
          delete: 'Vertrag Löschen',
          finish: 'Fertigstellen',
          next: 'Weiter',
          prev: 'Zurück'
        },
        deleteContractModal: {
          btn: {
            cancel: 'Nein, abbrechen',
            ok: 'Ja, sicher'
          },
          message: 'Sind Sie sicher, dass Sie diesen Vertrag inklusive aller Daten löschen wollen?',
          title: 'Vertrag löschen'
        },
        contractWizardModal: {
          btn: {
            submit: 'Schließen'
          },
          message: '<p>Ihr Vertrag wurde erfolgreich zur Vertragsübersicht hinzugefügt jedoch nicht komplett fertiggestellt.</p><div>Um Verträge fertigzustellen, müssen Sie eine bestätigte Kontaktperson und Adresse ausgewählt haben. Eines dieser beiden Elemente wurde noch nicht erfasst. Sie können mit der Fertigstellung des Vertrages fortfahren, indem Sie nach Bestätigung einer Kontaktperson und/oder Erfassung einer Adresse auf den jeweiligen Vertrag klicken und die fehlenden Elemente ergänzen</div>',
          title: 'Vertrag nicht fertiggestellt'
        },
        deleteContract: 'Der von Ihnen angegeben Vertrag wurde erfolgreich gelöscht',
        tabContent: {
          contractAddress: 'Adresse',
          contractEstate: 'Kontaktperson',
          contractInformation: 'Vetragsinformationen',
          contractPartner: 'Vertragspartner'
        }
      },
      contractsCard: {
        cancellationPeriod: {
          month: '{value} Monat',
          months: '{value} Monate'
        },
        noItems: 'Keine Daten vorhanden'
      },
      contractInformationForm: {
        contractCategoryModal: {
          btn: {
            ok: 'Weiter',
            cancel: 'Abbrechen'
          },
          message: 'Sind Sie sicher, dass Sie die Vertragskategorie ändern wollen? Bereits eingebene Informationen können zum Teil verloren gehen.',
          title: 'Vertragskategorie ändern'
        },
        label: {
          accountNumber: 'Kontonummer',
          cancellationPeriod: 'Kündigungsfrist',
          comment: 'Kommentar',
          conclusionDate: 'Vertragsabschluss',
          contractCategory: 'Kategorie',
          contractDuration: 'Vertragslaufzeit',
          contractNumber: 'Vertragsnummer',
          insuranceNumber: 'Vers.-Nr.',
          contractType: 'Vertragstyp',
          insuredPersonNumber: 'Kundennummer',
          link: 'Link',
          inMonths: '(in Monaten)',
          months: 'Monate',
          username: 'Benutzername / E-Mail Adresse'
        },
        contractPlaceholder: {
          unique: {
            insurance: ' z.B. Risikolebensversicherung, Haftpflichtversicherung, etc.',
            finance: 'z.B. Bausparvertrag',
            habitationHouseholdAndCommunication: 'z.B. Strom, Gas, Mobilfunkvertrag, etc.',
            leisureAndClub: 'z.B. Monatsbeitrag Fußballverein, Fitnessstudio, etc.',
            subscription: 'z.B. Zeitungsabonnement',
            onlineSubscriptionAndSocialMediaAccount: 'z.B. Musik-Streaming Abonnement, Facebook, etc.',
            other: 'z.B. Arbeitsvertrag, Spenden, etc.'
          },
          universal: {
            exampleUserContractNumber: 'z.B. 1234567'
          }
        },
        option: {
          null: 'Bitte legen Sie eine Vertragskategorie fest'
        }
      },
      contractList: {
        createContract: 'Der von Ihnen angelegte Vertrag wurde erfolgreich gespeichert',
        contractWizardTitle: {
          create: 'Neuen Vertrag erfassen',
          edit: 'Vertrag bearbeiten'
        },
        infoCard: {
          text: 'Hier können Sie Verträge zu Ihrer Vertragsübersicht hinzufügen. Um einen Vertrag zu erfassen werden Sie durch vier Schritte geführt.',
          step1: {
            title: 'Schritt 1:',
            contractPartnerName: 'Neuen Vertragspartner anlegen',
            message: 'Fügen Sie einen Vertragspartner hinzu. Falls dieser noch nicht angelegt worden ist, können Sie über die Option "Neuen Vertragspartner anlegen" einen neuen hinzufügen.'
          },
          step2: {
            title: 'Schritt 2:',
            message: 'Ordnen Sie den Vertrag einer entsprechenden Kategorie zu und ergänzen Sie die vertraglichen Details.'
          },
          step3: {
            title: 'Schritt 3:',
            message: 'Wählen Sie eine Adresse aus, auf die dieser Vertrag läuft.'
          },
          step4: {
            title: 'Schritt 4:',
            message: 'Ordnen Sie diesem Vertrag eine von Ihnen ausgewählte Kontaktperson zu, die nach Ihrem Ableben Einsicht in diesen Vertrag bekommt.'
          }
        },
        title: 'Verträge'
      },
      contractOverview: {
        label: {
          address: 'Vertragsadresse:',
          info: 'Vertragsdetails:',
          partner: 'Vertragspartner:'
        }
      },
      contractPartnerDetails: {
        label: {
          requiredFields: 'Alle mit ' + '<span class="text-danger">*</span>' + ' gekennzeichneten Felder sind Pflichtfelder',
          city: 'Stadt',
          confirmed: 'Ich bestätige hiermit, dass die obenstehenden Daten korrekt sind.',
          contractPartnerName: 'Firma / Vertragspartner',
          country: 'Land',
          domain: 'URL / Domain',
          email: 'E-Mail',
          street: 'Straße',
          streetNumber: 'Hausnummer',
          postOfficeBox: 'Postfach',
          postalCode: 'Postleitzahl'
        },
        infoText: 'Sollten sich diese Daten in der Zukunft ändern, sind Sie verpflichtet diese zu aktualisieren. Durch meine-vertraege.net werden keine automatischen Aktualisierungen der Daten vorgenommen.',
        placeholder: {
          contractPartner: 'Vertragspartner angeben'
        }
      },
      dashboard: {
        infobox: {
          addresses: {
            subtitle: 'Adressen'
          },
          contactPersons: {
            invitations: '{amount} weitere Einladung/en ausstehend',
            subtitle: 'Kontaktpersonen'
          },
          contracts: {
            completed: '{amount} davon noch nicht fertiggestellt',
            subtitle: 'Verträge'
          }
        },
        faq: {
          text: '<p>Über das Fenster "Wissenswertes" in der Navigationsleiste erfahren Sie wertvolle Informationen zu den Themen.<br>' +
            '<p><span class="ti-arrow-right"></span> Trauer - was ist das?</p>' +
            '<p><span class="ti-arrow-right"></span> Der Todesfall - was ist zu tun?</p>' +
            '<p><span class="ti-arrow-right"></span> Formen der Bestattung</p>' +
            '<p><span class="ti-arrow-right"></span> Todesanzeigen</p>' +
            '<p><span class="ti-arrow-right"></span> Beileidsbekundungen</p>',
          title: 'Wissenswertes'
        },
        info: {
          text: '<p><b>Vertragsmanager:</b><br><span class="ti-arrow-right"></span> Mit diesem Vertragsmanager können Sie Ihre Verträge einpflegen und verwalten. Alles auf einem Blick!<p>' +
            '<b>Todesmeldung an Vertragspartner:</b><br><span class="ti-arrow-right"></span> Wir werden uns darum kümmern, dass all Ihre Vertragspartner über Ihr Ableben informiert werden. Dies erspart Ihren engsten Vertrauten viel Zeit!<p>' +
            '<b>Bestimmung von Kontaktpersonen:</b><br><span class="ti-arrow-right"></span> Sie können Kontaktpersonen bestimmen, welche nach Ihrem Ableben Zugriff auf Ihre Verträge bekommen und so bestens über Ihre bestehenden Verträge informiert sind.',
          title: 'meine-vertraege.net - Ihr Digitaler Vertragsmanager'
        },
        powerOfAttorney: {
          address: '<br>CodeCamp:N GmbH<br>Solgerstraße 18<br>90429 Nürnberg',
          download: 'Vorlage herunterladen',
          explanation: '<p>Um die Vorteile von meine-vertraege.net in vollen Umfang nutzen zu können, benötigen wir von Ihnen eine Vollmachtserklärung. So können wir nach Ihrem Ableben Ihre Vertragspartner darüber informieren. Vor diesem Hintergrund ersparen Sie Ihren Hinterbliebenen viel Arbeit.' +
            '<p>Bitte befolgen Sie die folgenden Schritte um die Vollmacht zu erklären.',
          step1: '1. Vollmachtvorlage herunterladen & ausdrucken',
          step2: '2. Vollmacht handschriftlich unterzeichnen',
          step3: '3. Per Post an folgende Adresse verschicken oder unter "Mein Account" hochladen:',
          title: '<span class="ti-file mr-2"></span>Vollmacht erteilen'
        },
        title: 'Willkommen {userName} zu meine-vertraege.net'
      },
      dashboardContentContactPerson: {
        addRolePolicyHolder: 'Sie haben sich erfolgreich als versicherte Person registriert. Sie können nun den vollen Umfang von "meine-vertraege.net" nutzen',
        insurance: {
          btn: {
            submit: 'Weiter'
          },
          label: {
            dateOfBirth: 'Geburtsdatum',
            contractNumber: 'Vers.-Nr.'
          },
          message: 'Sollten Sie eine Sterbegeldversicherung bei der NÜRNBERGER Versicherung abgeschlossen haben, können Sie hier Ihre Versicherungsnummer eingeben. Damit erhalten Sie Zugang zum vollen Funktionsumfang der Plattform meine-vertrage.net. Dazu gehört die Erfassung all Ihrer Vertragsverhältnisse, dem Anlegen von Adressen und dem Bestimmen von Kontaktpersonen, die nach Ihrem Ableben Einsicht in Ihren Vertragsmanager bekommen.',
          title: 'Haben Sie schon eine Sterbegeldversicherung?'
        },
        message: 'Personen, die Sie als Kontaktperson angelegt haben',
        numberOfAssignedContract: 'Vertrag',
        numberOfAssignedContracts: 'Verträge'
      },
      footer: {
        copyright: '© 2018',
        imprint: 'Impressum',
        privacyPolicies: 'Datenschutzrichtlinien',
        terms: 'Nutzungsbedingungen',
        info: 'Info'

      },
      faq: {
        collapse: 'Weiterlesen',
        title: 'Wissenswertes'
      },
      imprint: {
        title: 'Impressum'
      },
      info: {
        title: 'Informationen'
      },
      personalInformationForm: {
        btn: {
          cancel: 'Abbrechen',
          edit: 'Bearbeiten',
          save: 'Speichern'
        },
        label: {
          dateOfBirth: 'Geburtsdatum',
          firstName: 'Vorname',
          lastName: 'Nachname',
          salutation: 'Anrede',
          title: 'Titel'
        }
      },
      policies: {
        title: 'Datenschutzhinweise'
      },
      policyHolderContracts: {
        back: 'Zurück'
      },
      policyHolderDetails: {
        certificateOfDeath: 'Sterbeurkunde',
        certificateOfDeathEnable: 'Das Dokument wurde erfolgreich hochgeladen. Wir werden Ihnen nach erfolgreicher Legitimierung den Zugang zur Vertragsübersicht von {policyHolderName} freischalten.',
        certificateOfDeathMessage: 'Sterbeurkunde anzeigen',
        certificateOfInheritance: 'Erbschein',
        certificateOfInheritanceEnable: 'Das Dokument wurde erfolgreich hochgeladen. Wir werden Ihnen nach erfolgreicher Legitimierung den Zugang zur Vertragsübersicht von {policyHolderName} freischalten.',
        certificateOfInheritanceMessage: 'Erbschein anzeigen',
        deleteDocument: 'Dokument entfernen',
        infoText: 'Sie wurden als Kontaktperson von {policyHolderName} festgelegt. Um Einsicht in die Ihnen zugeordneten Verträge zu erhalten, benötigen wir im Todesfall eine Sterbeurkunde für {policyHolderName} um Ihnen Zugriff auf die Ihnen zugeordneten Verträge geben zu können. Dies versetzt uns in die Lage, die Vertragspartner von {policyHolderName} über das Ableben in Kenntnis zu setzen. Sollen Sie in Besitz eines entsprechenden Erbscheins sein, so wird Ihnen nach dem Hochladen die uneingeschränkte Vertragseinsicht gewährt.',
        infoText2: 'Hier sehen Sie alle Verträge, die {policyHolderName} Ihnen zugeordnet hat.',
        modal: {
          cancel: 'Nein, Abbrechen',
          message: 'Möchten Sie das Dokument wirklich entfernen?',
          ok: 'Ja, sicher',
          title: 'Dokument entfernen?'
        },
        reportDeath: '{policyHolderName} als tot melden:',
        uploadCertificateOfDeath: 'Die von Ihnen ausgewählte Datei wurde erfolgreich als Sterbeurkunde hochgeladen',
        uploadCertificateOfInheritance: 'Die von Ihnen ausgewählte Datei wurde erfolgreich als Erbschein hochgeladen',
        title: 'Vertragsübersicht von {firstName} {lastName}'
      },
      resetPassword: {
        title: 'Passwort vergessen?',
        message: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Kennwort zurückzusetzen. Eventuell müssen Sie den Spamordner prüfen, oder die Adresse als Absender zulassen.',
        btn: {
          send: 'Senden',
          back: 'Zurück'
        },
        input: {
          email: {
            placeholder: 'E-Mail-Adresse'
          }
        }
      },
      resetPasswordConfirm: {
        btn: {
          back: 'Zurück',
          send: 'Senden'
        },
        label: {
          password: 'Passwort',
          passwordConfirm: 'Passwort bestätigen',
          verificationCode: 'Aktivierungscode'
        },
        input: {
          placeholder: {
            password: 'Geben Sie hier Ihr neues Passwort ein',
            passwordConfirm: 'Geben Sie hier Ihr neues Passwort erneut ein',
            verificationCode: 'Geben Sie hier Ihren Aktivierungscode ein'
          }
        },
        message: '',
        title: 'Neues Passwort vergeben'
      },
      signIn: {
        autoLogout: 'Guten Tag {salutation} {firstName} {lastName}, Sie waren länger als 20 Minuten inaktiv und wurden automatisch ausgeloggt. Sie können sich im untenstehenden Anmeldeformular erneut anmelden',
        input: {
          placeholder: {
            email: 'Bitte geben Sie hier Ihre E-Mail-Adresse ein',
            password: 'Bitte geben Sie hier Ihr Passwort ein'
          }
        },
        label: {
          email: 'E-Mail-Adresse'
        },
        title: 'Anmelden'
      },
      signUp: {
        btn: {
          submit: 'Registrieren'
        },
        label: {
          dateOfBirth: 'Geburtstag',
          email: 'E-Mail-Adresse',
          firstName: 'Vorname',
          contractNumber: 'Versicherungsnummer',
          lastName: 'Nachname',
          relation: 'Angehörigkeit zu {salutation} {firstName} {lastName}',
          salutation: 'Anrede',
          password: 'Passwort',
          passwordConfirm: 'Passwort bestätigen'
        },
        link: 'Hier registrieren',
        radio: {
          mister: 'Herr',
          miss: 'Frau'
        },
        question: 'Haben Sie noch keinen Account? ',
        privacyPolicies: 'Datenschutzrichtlinien',
        signIn: 'Haben Sie schon einen Account? {signInLink}',
        signInHere: 'Hier anmelden',
        terms: 'Nutzungsbedingungen',
        termsAndPolicies: 'Ich stimme den {terms} und {privacyPolicies} zu.',
        title: 'Registrierung'
      },
      signUpConfirm: {
        activated: 'Ihr Account wurde erfolgreich aktiviert. Sie können sich nun anmelden',
        again: 'Wenn Sie noch keine E-Mail erhalten haben, {resendLink}. Falls Sie erneut keine E-Mail erhalten, wenden Sie sich bitte an unseren Support unter {supportLink}.',
        btn: {
          back: 'Zurück',
          resend: 'klicken Sie hier um die E-Mail erneut zu senden',
          send: 'Aktivieren'
        },
        input: {
          placeholder: {
            verificationCode: 'Aktivierungscode'
          }
        },
        message: 'Vielen Dank für Ihre Registrierung. Bitte geben Sie den an Ihre E-Mail-Adresse gesendeten Aktivierungscode ein, um die Registrierung abzuschließen.',
        title: 'Bestätigung Ihrer Registrierung'
      },
      signUpContactPerson: {
        accountOptions: {
          no: 'Nein, noch nicht',
          yes: 'Ja, habe ich'
        },
        btn: {
          submit: 'Weiter'
        },
        label: {
          acceptRequest: 'Möchten Sie die Anfrage als Kontaktperson annehmen?',
          hasAccount: 'Haben Sie bereits einen Account bei meine-vertraege.net?',
          relation: 'Angehörigkeit zu {salutation} {firstName} {lastName}'
        },
        requestOptions: {
          no: 'Nein, ablehnen',
          yes: 'Ja, annehmen'
        },
        title: 'Kontaktpersonenanfrage von {salutation} {firstName} {lastName}'
      },
      signUpContactPersonRejected: {
        title: 'Anfrage abgelehnt',
        message: '<p>Vielen Dank für Ihre Antwort. Wir werden den Einlader informieren, dass Sie die Anfrage abgelehnt haben.</p><p>Mit freundlichen Grüßen</p>Ihr Team von meine-vertraege.net'
      },
      support: {
        email: 'support@meine-vertraege.net'
      },
      terms: {
        title: 'Nutzungsbedingungen digitaler Vertragsmanager'
      }
    },
    error: {
      accountDetails: {
        deletePowerOfAttorney: {
          common: 'Beim Versuch Ihre Vollmacht zu widerrufen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
          notFound: 'Es existiert keine Vollmacht, die widerrufen werden könnte'
        },
        getPowerOfAttorney: 'Beim Versuch Ihre Vollmacht anzuzeigen ist ein Fehler unterlaufen. Bitte Versuchen Sie es später erneut',
        saveChangedPassword: {
          common: 'Beim Versuch Ihr neues Passwort zu speichern ist ein Fehler unterlaufen',
          limitExceeded: 'Das Passwort wurde zu oft geändert. Bitte versuchen Sie es später erneut'
        },
        saveChangedEmail: 'Beim Versuch Ihre neue E-Mail-Adresse zu speichern ist ein Fehler unterlaufen'
      },
      accountPowerOfAttorneyForm: {
        uploadFailure: 'Fehler beim Hochladen der Vollmacht'
      },
      addressDetails: {
        changedAdresses: 'Es ist ein Fehler unterlaufen. Bitte versuchen Sie es erneut',
        contractsByAddress: 'Es ist ein Fehler beim Laden der Verträge zu dieser Adresse unterlaufen. Bitte versuchen Sie es erneut',
        deleteAddress: 'Es ist ein Fehler unterlaufen. Bitte versuchen Sie es erneut',
        fetchAddressById: 'Beim Laden der Adresse ist ein Fehler unterlaufen. Bitte versuchen Sie es erneut',
        saveAddress: 'Es ist ein Fehler unterlaufen. Bitte versuchen Sie es erneut'
      },
      addressConfirmForm: {
        storeAddress: 'Beim Versuch die von Ihnen angegebene Adresse zu speichern ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      addressForm: {
        street: 'Bitte geben Sie eine Straße an',
        streetNumber: 'Bitte geben Sie eine Hausnummer an',
        postalCode: 'Bitte geben Sie eine Postleitzahl an',
        city: 'Bitte geben Sie eine Stadt an',
        country: 'Bitte geben sie ein Land an'
      },
      addressSearchForm: {
        autocomplete: 'Bitte selektieren Sie einen Ort aus der Auswahlliste'
      },
      adminContractPartnerDetails: {
        fetchContractPartnerTemplateById: 'Beim Versuch den angegebenen Vertragspartner zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        saveContractPartner: 'Beim Versuch den angegebenen Vertragspartner als Template zu speichern ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      adminContractPartnerTemplateDetails: {
        deleteAdminContractPartnerTemplate: 'Beim Versuch das angegebene Template zu löschen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        fetchAdminContractPartnerTemplateById: 'Beim Versuch das angegebene Template zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        saveContractPartnerTemplate: 'Beim Versuch das angegegebene Template zu speichern ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      adminUserStatus: {
        update: {
          death: 'Sterbedatum erfolgreich aktualisiert',
          legi: 'Legitimationsstatus erfolgreich aktualisiert'
        }
      },
      avatar: {
        delete: 'Fehler beim Löschen',
        fileToolarge: 'Bilddatei zu groß',
        uploadFail: 'Fehler beim Upload',
        wrongDimensions: 'Ungültige Bildabmessungen',
        wrongFileType: 'Dieses Format wird nicht unterstützt'
      },
      changePasswordForm: {
        oldPassword: 'Bitte geben Sie Ihr altes Passwort ein',
        newPassword: 'Bitte geben Sie mindestens 6 Zeichen ein, davon: 1 Großbuchstabe, 1 Kleinbuchstabe, eine Zahl und/oder ein Sonderzeichen',
        newPasswordConfirm: 'Die angegebenen Passwörter sind leer oder stimmen nicht über ein'
      },
      contactPersonDetails: {
        contactPersonById: 'Beim Laden der Kontaktperson ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        deleteContactPerson: 'Beim Versuch die von Ihnen ausgewählte Kontaktperson zu löschen, ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
        fetchContractsByContactPerson: 'Beim Laden der Verträge, die der Kontaktperson zu geordnet sind, ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      contactPersonList: {
        submitContentPersonDialog: 'Beim Versuch die Einladung an Ihre Kontaktperson zu versenden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      contractPartnerDetails: {
        contractPartner: {
          city: 'Bitte geben Sie eine Stadt an',
          confirmed: 'Bitte bestätigen Sie die Echtheit Ihrer Angeben',
          country: 'Bitte geben Sie ein Land an',
          contractPartnerName: 'Bitte geben Sie eine Firma oder einen Vertragspartner an',
          domain: 'Bitte geben Sie eine Domain an',
          email: 'Bitte geben Sie eine E-Mail an',
          street: 'Bitte geben Sie eine Straße an',
          streetNumber: 'Bitte geben Sie eine Hausnummer an',
          postOfficeBox: 'Bitte geben Sie ein Postfach an',
          postalCode: 'Bitte geben Sie eine Postleitzahl an'
        }
      },
      contractInformationForm: {
        accountNumber: 'Bitte geben Sie eine gültige Kontonummer an',
        cancellationPeriod: 'Bitte geben Sie eine gültige Zahl mit maximal 2 Stellen als Kündigungsfrist ein',
        comment: 'Bitte geben Sie maximal 325 Zeichen für einen gültigen Kommentar ein',
        conclusionDate: 'Das angegebene Datum ist leider ungültig.',
        contractDuration: 'Bitte geben Sie eine gültige Zahl mit maximal 3 Stellen als Vertragslaufzeit ein',
        contractNumber: 'Bitte geben Sie eine gültige Vertragsnummer an',
        contractType: 'Bitte geben Sie maximal 100 Zeichen für einen gültigen Vertragstyp ein',
        insuredPersonNumber: 'Bitte geben Sie ein gültige Kundennummer ein',
        link: 'Bitte geben Sie eine gültige URL im Format "http://codecamp-n.de", oder "www.codecamp-n.de" ein',
        username: 'Bitte geben Sie Ihren Benutzernamen bzw. Ihre E-Mail ein'
      },
      contractList: {
        create: 'Beim Anlegen Ihres Vertragspartners ist ein Fehler unterlaufen',
        check: 'Bitte überprüfen Sie Ihre Eingaben',
        estateAdministration: {
          type: 'Bitte selektieren Sie eine der möglichen Nachlassregelungen',
          personOfTrust: 'Bitte selektieren Sie eine Kontaktperson'
        },
        fetchContracts: 'Beim Versuch Ihre Verträge zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        fetchContractById: 'Beim Versuch den angegebenen Vertrag zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        invalid: 'Bitte überprüfen Sie Ihre Eingaben und befüllen Sie alle Pflichtfelder',
        missing: 'Bitte geben Sie einen Vertragspartner an',
        noContractPartnerFounded: 'Der gewünschte Vertragspartner konnte nicht gefunden werden. Bitte legen Sie einen neuen an.'
      },
      contractPartnerForm: {
        contractPartner: {
          company: 'Bitte geben Sie einen Vertragspartner an '
        }
      },
      contractWizard: {
        deleteContract: 'Beim Versuch den Vertrag zu löschen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        storeContract: 'Beim Versuch den Vertrag zu speichern ist ein Fehler unterlaufen. Bitte veruschen Sie es später erneut'
      },
      dashboardContentContactPerson: {
        addRolePolicyHolder: 'Ihre Versicherungsnummer konnte nicht validiert werden, bitte überprüfen Sie Ihre Eingaben. Sollten Sie weiterhin Probleme bei der Registrierung haben, melden Sie sich unter support@meine-vertraege.net.',
        contractNumber: 'Diese Versicherungsnummer ist nicht gültig. Bitte überprüfen Sie Ihre Eingabe',
        dateOfBirth: 'Bitte geben Sie ein gültiges Datum im Format "TT.MM.JJJJ" ein'
      },
      personalInformationForm: {
        dateOfBirth: 'Bitte geben Sie ein gültiges Datum im Format "TT.MM.JJJJ" ein',
        firstName: 'Bitte geben Sie Ihren Vornamen ein',
        lastName: 'Bitte geben Sie Ihren Nachnamen ein',
        salutation: 'Bitte geben Sie eine Anrede an'
      },
      policyHolderDetails: {
        policyHolderById: 'Beim Versuch die angegebene Kontaktperson zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        deleteCertificateOfDeath: 'Beim Versuch die Sterbeurkunde hoch zu löschen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        uploadCertificateOfDeath: 'Beim Versuch die angegebene Datei, als Sterbeurkunde hoch zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        deleteCertificateOfInheritance: 'Beim Versuch den Erbschein zu löschen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        uploadCertificateOfInheritance: 'Beim Versuch die angegebene Datei, als Erbschein hoch zu laden ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut',
        fileReaderError: 'Beim Versuch Ihre Datei einzulesen ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      resetPassword: {
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        submit: 'Benutzername {email} unbekannt'
      },
      resetPasswordConfirm: {
        submit: 'Der angegebene Benutzer konnte nicht gefunden werden oder der eingegebene Aktivierungscode ist ungültig. Bitte versuchen Sie es erneut, oder wenden Sie sich an unseren Support unter {supportLink}',
        password: 'Bitte geben Sie mindestens 6 Zeichen ein, davon: 1 Großbuchstabe, 1 Kleinbuchstabe, eine Zahl und/oder ein Sonderzeichen',
        passwordConfirm: 'Die angegebenen Passwörter sind leer oder stimmen nicht über ein',
        verificationCode: 'Bitte geben Sie einen Aktivierungscode ein'
      },
      signIn: {
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        password: 'Bitte geben Sie ein Passwort ein',
        submit: 'Der Benutzername oder das Passwort sind nicht korrekt',
        death: 'Dieses Konto ist nicht länger zugänglich. Bei Fragen kontaktieren Sie bitte support@meine-vertraege.net',
        error: 'Es ist ein Fehler unterlaufen. Bitte versuchen Sie es später erneut'
      },
      signUp: {
        acceptTerms: 'Bitte akzeptieren Sie die Nutzungsbedingungen und Datenschutzrichtlinien',
        dateOfBirth: 'Bitte geben Sie ein gültiges Datum im Format "TT.MM.JJJJ" ein',
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        firstName: 'Bitte geben Sie Ihren Vornamen ein. Es sind nur Buchstaben erlaubt',
        contractNumber: 'Diese Versicherungsnummer ist nicht gültig. Bitte überprüfen Sie Ihre Eingabe',
        lastName: 'Bitte geben Sie Ihren Nachnamen ein. Es sind nur Buchstaben erlaubt',
        password: 'Bitte geben Sie mindestens 6 Zeichen ein, davon: 1 Großbuchstabe, 1 Kleinbuchstabe, eine Zahl und/oder ein Sonderzeichen',
        passwordConfirm: 'Die eingegebenen Passwörter stimmen nicht überein',
        salutation: 'Bitten wählen Sie eine der beiden Optionen aus',
        submit: 'Beim Versuch Ihre Daten zu speichern ist ein Fehler aufgetreten. Bitte wenden Sie sich an unseren Support unter {supportLink}',
        relation: 'Bitte wählen Sie eine Angehörigkeit aus'
      },
      signUpConfirm: {
        expired: 'Der von Ihnen eingegebene Aktivierungscode ist abgelaufen. Bitte wenden Sie sich an unseren Support unter {supportLink}',
        resend: 'Es konnte zu dem angegebenen Benutzer kein Aktvierungscode generiert werden. Bitte wenden Sie sich an unseren Support unter {supportLink}',
        submit: 'Der von Ihnen eingegebene Aktivierungscode ist ungültig. Bitte versuchen Sie es erneut, oder wenden Sie sich an unseren Support unter {supportLink}',
        verificationCode: 'Bitte geben Sie einen Aktivierungscode ein'
      },
      signUpContactPerson: {
        delete: 'Beim Versuch Ihre Einladung zu löschen ist ein Fehler unterlaufen. Bitten wenden Sie sich an unseren Support'
      }
    }
  }
}

export default messages




// WEBPACK FOOTER //
// ./src/i18n/messages.js